import { render, staticRenderFns } from "./SlideSpalProcess.vue?vue&type=template&id=7284f2af&scoped=true"
import script from "./SlideSpalProcess.vue?vue&type=script&lang=js"
export * from "./SlideSpalProcess.vue?vue&type=script&lang=js"
import style0 from "./SlideSpalProcess.vue?vue&type=style&index=0&id=7284f2af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284f2af",
  null
  
)

export default component.exports